import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const ShootUse = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('shoot_item2'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])
    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('shoot_use_faq')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 15 }}>{t('shoot_use_faq1')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('shoot_use_faq1_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('shoot_use_faq2')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('shoot_use_faq2_detail')}</span>
                <span style={{ fontSize: 14, color: '#666666', lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('shoot_use_faq2_detail_prerecord')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('shoot_use_faq3')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('shoot_use_faq3_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('shoot_use_faq4')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('shoot_use_faq4_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('shoot_use_faq5')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('shoot_use_faq5_detail')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 30 }}>{t('shoot_use_faq6')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('shoot_use_faq6_detail')}</span>
            </div>
            <div style={{ height: 40 }} />
        </div>
    </div>
}

export default ShootUse